import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Announcements from './views/Announcements.vue'
import Operations from './views/Operations.vue'
import VehiclesNew from './views/Vehicles_New.vue'
import Site from './views/Site.vue'
import Alarm from './views/Alarm.vue'
import Group from './views/Group.vue'
import TourMZF from './views/Tour_MZF.vue'
import TourLF from './views/Tour_LF.vue'
import TourHLF from './views/Tour_HLF.vue'
import Redesign from './views/Redesign.vue'
import Devices from './views/Devices.vue'
import Youth from './views/Youth.vue'

Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    if(to.hash)
      return { selector: to.hash }
    else if(savedPosition)
      return savedPosition;
    else 
      return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/aktuelles',
      name: 'announcements',
      component: Announcements
    },
    {
      path: '/einsatz',
      name: 'operations',
      component: Operations
    },
    {
      path: '/fahrzeug',
      name: 'fahrzeug',
      component: VehiclesNew
    },
    {
      path: '/standort',
      name: 'standort',
      component: Site
    },
    {
      path: '/group',
      name: 'group',
      component: Group
    },
    {
      path: '/alarm',
      name: 'alarm',
      component: Alarm
    },
    {
      path: '/tour_mzf',
      name: 'tour_mzf',
      component: TourMZF
    },
    {
      path: '/tour_lf',
      name: 'tour_lf',
      component: TourLF
    },
    {
      path: '/tour_hlf',
      name: 'tour_hlf',
      component: TourHLF
    },
    {
      path: '/tests',
      name: 'tests',
      component: Redesign
    },
    {
      path: '/devices',
      name: 'devices',
      component: Devices
    },
    {
      path: '/jugend',
      name: 'jugend',
      component: Youth
    }
  ]
})
